import { HttpClient, HttpParams } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { eps } from './url.service'
import { catchError, Observable, of } from 'rxjs'
import { Holiday } from '../components/leaves/holidays/holidays.component'
import { AssignedTo, LeavePolicy } from '../store/leave-policy/leave-policy.state'

@Injectable({
  providedIn: 'root'
})
export class LeavePolicyService {
  private http = inject(HttpClient) // Use inject() instead of constructor injection
  private api = eps.leaves

  list(businessId?: string, search?: string, page?: number, limit?: number): Observable<any> {
    let params = new HttpParams()
    if (businessId) {
      params = params.set('businessId', businessId)
    }
    if (search) {
      params = params.set('title', search)
    }
    if (page) {
      params = params.set('page', page)
    }
    if (limit) {
      params = params.set('limit', limit)
    }
    return this.http.get<any>(this.api.policiesApi, { params })
  }

  getLeavePolicyById(id: string): Observable<LeavePolicy> {
    return this.http.get<LeavePolicy>(`${this.api.policiesApi}/${id}`)
  }

  create(holiday: Holiday): Observable<Holiday> {
    return this.http.post<Holiday>(this.api.policiesApi, holiday)
  }

  update(id: string, holiday: Holiday): Observable<Holiday> {
    return this.http.put<Holiday>(`${this.api.policiesApi}/${id}`, { ...holiday })
  }

  delete(id: string): Observable<Holiday> {
    return this.http.delete<Holiday>(`${this.api.policiesApi}/${id}`)
  }

  assignedPolicyList(
    businessId: string,
    leavePolicyId: string,
    page: number,
    limit: number,
    isEmployeeActive: boolean,
    search?: string,
    userId?: string
  ): Observable<any> {
    let params = new HttpParams()
    params = params.set('businessId', businessId)
    params = params.set('leavePolicyId', leavePolicyId)
    params = params.set('page', page)
    params = params.set('limit', limit)
    params = params.set('isEmployeeActive', isEmployeeActive)
    if (search) params = params.set('search', search)
    if (userId) params = params.set('userId', userId)

    return this.http.get<any>(this.api.assignedPolicyApi, { params })
  }

  assignedPolicyByUserId(userId: string): Observable<any> {
    const url = `${this.api.assignedPolicyApi}/${userId}`
    console.log('url root:::>', url)
    return this.http.get<any>(url).pipe(catchError(() => of([])))
  }

  assignPolicy(data: any): Observable<any> {
    return this.http.post<any>(this.api.assignedPolicyApi, data)
  }

  getAssignedTo(
    leavePolicyId: string,
    params?: string | null,
    page?: number,
    limit?: number
  ): Observable<any> {
    console.log('params', params)
    const url = params
      ? `${this.api.assignedPolicyApi}/assignedTo/${leavePolicyId}?${params}&page=${page}&limit=${limit}`
      : `${this.api.assignedPolicyApi}/assignedTo/${leavePolicyId}?page=${page}&limit=${limit}`
    return this.http.get<any>(url)
    // return this.http.get<any>(`${this.api.assignedPolicyApi}/assignedTo/${leavePolicyId}`)
  }

  getUnAssignedTo(
    leavePolicyId: string,
    params?: string | null,
    page?: number,
    limit?: number
  ): Observable<any> {
    const url = params
      ? `${this.api.assignedPolicyApi}/UnassignedTo/${leavePolicyId}?${params}&page=${page}&limit=${limit}`
      : `${this.api.assignedPolicyApi}/UnassignedTo/${leavePolicyId}?page=${page}&limit=${limit}`
    return this.http.get<any>(url)
    // return this.http.get<any>(`${this.api.assignedPolicyApi}/assignedTo/${leavePolicyId}`)
  }

  setDefaultPolicy(policyId: string): Observable<{ message: string; data: any }> {
    return this.http.patch<{ message: string; data: any }>(
      `${this.api.policiesApi}/${policyId}/default`,
      {}
    )
  }

  updateLeaveBalance(payload: {
    userId: string
    leavePolicyId: string
    balance: number
    reason?: string
  }) {
    return this.http.post(eps.employeeleavebalance.employeeleavebalanceApi, payload)
  }

  deleteAssignedTo(id: string): Observable<AssignedTo[]> {
    return this.http.delete<AssignedTo[]>(`${this.api.assignedPolicyApi}/${id}`)
  }

  getAccrual(params?: string | null): Observable<Record<string, any[]>> {
    const url = params
      ? `${eps.employeeleavebalance.employeeleavebalanceApi}?${params}`
      : `${eps.employeeleavebalance.employeeleavebalanceApi}`

    return this.http.get<Record<string, any[]>>(url)
  }
}
